module.exports = __webpack_public_path__ + "assets/img/deco-1.f93a944c.png";